import type { ReadonlyURLSearchParams } from 'next/navigation'

type Query = {
  [key: string]: string | string[] | undefined
}

const getParam = (
  query: Query | ReadonlyURLSearchParams | undefined | null,
  param: string
): string | string[] | undefined => {
  if (!query) return undefined
  if (query instanceof URLSearchParams) return query.get(param) ?? undefined
  return query[param]
}

export const getSingleParam = (
  query: Query | ReadonlyURLSearchParams | undefined | null,
  key: string
): string | undefined => {
  const value = getParam(query, key)
  return Array.isArray(value) ? value[0] : value
}

const demandParam = (
  query: Query | ReadonlyURLSearchParams | undefined | null,
  param: string
): string => {
  if (typeof query === 'undefined' || query === null) {
    throw new Error('`query` is undefined')
  }

  const value = getParam(query, param)

  if (typeof value === 'string') {
    return value
  } else if (typeof value === 'object') {
    throw new Error(`Multiple values passed for param "${param}"`)
  } else {
    throw new Error(`No value passed for param "${param}"`)
  }
}

export default demandParam
